export const environment = {
    //"urlProveedor" : "https://localhost:44328/" // En Desarrollo
    "urlProveedor" : "https://apiproveedoreshm.hospitalmetropolitano.org/"
}